module.exports = __webpack_public_path__ + "a1cc0ed31027782a06c9e9f87d024dbe.png";